export default function initDottedGraphicLine() {

	const init = () => {
        
        if (document.querySelector('.internal-page-nav-page-dropdown-section')) {
            const journeyTrail = document.querySelector('.journey-trail');
            const journeyStages = document.querySelectorAll('.journey-stage');

            if (journeyStages) {
                journeyStages[journeyStages.length - 1].classList.add('last');
                journeyStages[0].classList.add('first');
                if (journeyTrail) journeyTrail.classList.add('has-journey');

                if (document.querySelector('.journey-trail') ) {
                    window.addEventListener('resize', onJourneyLineArtResize );
                    onJourneyLineArtResize();
                }
            }
        }

        let graphicLineCardSet = document.querySelector('section.graphic-line-card-grid') || document.querySelector('section.graphic-line-card-stack') || document.querySelector('section.b-graphic-line-text-stack');
        if (graphicLineCardSet && document.querySelector('section.hero-section.variation-graphic')) {
			window.addEventListener('resize', onGraphicLineResize );
			onGraphicLineResize();
		}
	};

	

    const onGraphicLineResize = () => {
        const graphicLineset = document.querySelector('section.hero-section.variation-graphic .line-set');
        if(!graphicLineset ) return false;
        const rightHeroLine = graphicLineset.querySelector('.line-set .line-right');
        const centerHeroLine = graphicLineset.querySelector('.line-set .line-center');
        const leftHeroLine = graphicLineset.querySelector('.line-set .line-left');
        const dottedLine = document.querySelector('.graphic-line-card-grid .dotted-line') || document.querySelector('.graphic-line-card-stack .dotted-line') || document.querySelector('.b-graphic-line-text-stack .dotted-line');

        const dLineWidth = dottedLine.getBoundingClientRect().width;
        const rightHeroLineLeft = rightHeroLine.getBoundingClientRect().left;
        const dottedLineLeft = dottedLine.getBoundingClientRect().left;
        const leftX = (dottedLineLeft - rightHeroLineLeft) + (window.matchMedia('(max-width: 1200px)').matches ? 4 : 34);
        leftHeroLine.style.left = leftX  + 'px';
        console.log( );
        centerHeroLine.style.left = ((leftX + leftHeroLine.getBoundingClientRect().width) + 3) +'px';
        centerHeroLine.style.width = Math.abs( leftX + 72) + 'px';

    };

    const onJourneyLineArtResize = () => {
        const linesetContainer = document.querySelector('.journey-trail');
        const lineset = linesetContainer.querySelector('.line-set');
        const firstStage = document.querySelectorAll('.journey-stage:not(.is-hidden')[0];
        const firstDottedLine = firstStage.querySelector('.dotted-line');

        if (lineset) {
            const firstDottedLineLeft = firstDottedLine.getBoundingClientRect().left;
            lineset.style.left = firstDottedLineLeft + 33 + 'px';
            const linesetWidth = window.innerWidth / 2 - firstDottedLineLeft - 33;
            lineset.style.width = linesetWidth + 'px';
            const linesetRight = lineset.querySelector('.line-right img');
            const linesetLeft = lineset.querySelector('.line-left img');
            const verticalMiddle = linesetContainer.getBoundingClientRect().height / 2;
            linesetLeft.style.transform = `translateY(${verticalMiddle}px)`;
            linesetRight.style.transform = `translateY(${verticalMiddle - linesetRight.getBoundingClientRect().height + 1}px)`;
        }

        moveDottedLines();
    };

    const moveDottedLines = () => {

        let section = document.querySelector('section.graphic-line-card-stack');
        if (section) {
            let lines = section.querySelector('.dotted-line');
            let heroLine = document.querySelector('.hero-section.variation-graphic .arrow-line');
            if (lines && heroLine) {
                lines.style.left = `${heroLine.getBoundingClientRect().left}px`;
            }
        }
    };

	init();
}

